/*
 * hashes reducer
 */
import { RESET_STATE } from '../auth/constants';
import { SET_CURRENT_ORGANIZATION_ID } from '../currentOrganizationId/constants';
import { SET_CURRENT_SEASON_ID } from '../currentSeasonId/constants';
import SET_HASH from './constants';

type State = {};

type Action = {
    +type: string,
    +payload: Object
};

const initialState = {};

export default function(state?: State = initialState, action?: Action) {
    if (!action) return state;
    switch (action.type) {
        case SET_HASH:
            return {
                ...state,
                [action.payload.namespace]: action.payload.hash
            };
        case RESET_STATE:
        case SET_CURRENT_ORGANIZATION_ID:
        case SET_CURRENT_SEASON_ID:
            return initialState;
        default:
            return state;
    }
}
